import { byteSize } from "../../common/byte-size";

// Everything a cipher on this page does is over the whole message at once — an AEAD tag covers all of it, and OpenPGP
// builds one literal packet — so a file is held in memory rather than walked the way /hasher walks one, and the cap
// is what says so before somebody drops a disc image on it.
export const MAX_BYTES = 16 * 1024 * 1024;

export async function readFileBytes(file: File): Promise<Uint8Array> {
  if (file.size > MAX_BYTES) throw new Error(`That file is larger than the ${byteSize(MAX_BYTES)} this reads`);
  return new Uint8Array(await file.arrayBuffer());
}

export interface Loaded {
  name: string;
  size: number;
  bytes: Uint8Array;
}
